module.exports = __webpack_public_path__ + "img/ring_g_skip_null_1@3x.2613a6ef.png";